import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: '../../templates/error/page-not-found.component.html'
})
export class PageNotFoundComponent {}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/error/page-not-found.component.ts